// extracted by mini-css-extract-plugin
export var inline = "_wa-0";